import { render, staticRenderFns } from "./ModuleStakewiseStake.vue?vue&type=template&id=1590a860&scoped=true"
import script from "./ModuleStakewiseStake.vue?vue&type=script&lang=js"
export * from "./ModuleStakewiseStake.vue?vue&type=script&lang=js"
import style0 from "./ModuleStakewiseStake.vue?vue&type=style&index=0&id=1590a860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590a860",
  null
  
)

export default component.exports